import React, { useState } from 'react';
import Button from '../components/button/Button.tsx';
import { toast } from 'react-toastify';
import { ParseErrors } from '../utils/parse-errors.ts';
import axiosInstance from '../utils/axios-instance.ts';
import { Link, useNavigate } from 'react-router-dom';


const SignUp = () => {
  const [values, setValues] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState<boolean>(false);
  const NavigateTo = useNavigate()

  const HandleRegister = async () => {
    if (validate()) {
      setLoading(true)
      try {
        const response = await axiosInstance.post('/auth/register', { ...values, type: "agency" })
        NavigateTo("/login")
        toast.success(response.data.message)
        setLoading(false)
      } catch (error) {
        console.log(error)
        toast.error(ParseErrors(error))
        setLoading(false)
      }
    }
  }


  const HandleChangeValues = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }


  const validate = () => {
    if (!values.email) {
      toast.error("Please enter email address")
      return false
    } else if (!values.email?.includes('@')) {
      toast.error("Please enter a valid email address")
      return false
    } else if (!values.password) {
      toast.error("Please enter password")
      return false
    } else if (values?.password !== values?.confirmPassword) {
      toast.error("Passwords do not match")
      return false
    } else {
      return true
    }
  }

  return (
    <div className='w-full min-h-screen bg-white flex justify-center items-stretch'>
      <div className='lg:flex hidden lg:w-[50%] bg-gradient-to-br from-yellow/10 via-white to-blue/10 relative items-center justify-center overflow-hidden'>
        <div className="absolute -top-40 -left-40 h-96 w-96 rounded-full bg-yellow/15 blur-3xl"></div>
        <div className="absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-blue/15 blur-3xl"></div>
        <img className='relative w-[80%] max-w-md' src='/assets/images/signup.png' alt='Signup' />
      </div>

      <div className="w-full md:w-[60%] lg:w-[50%] flex flex-col items-center justify-center py-16 lg:py-0 px-5">
        <div className="w-full lg:max-w-md fade-up">
          <Link to="/" className="inline-block mb-10">
            <img src="/assets/images/coachai.png" alt="Coach AI" className="w-[90px]" />
          </Link>
          <h2 className="font-display text-3xl lg:text-4xl font-semibold tracking-tight text-lightBlack mb-2">Create your account</h2>
          <p className="text-gray-500 text-[15px] mb-8">Start coaching with AI in seconds — no credit card required.</p>

          <div className="space-y-5">
            <div>
              <label className="block text-[13px] font-medium text-lightBlack mb-1.5">Email</label>
              <input
                type="email"
                name='email'
                placeholder="you@example.com"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-[14.5px] placeholder-gray-400"
                value={values?.email || ""}
                onChange={HandleChangeValues}
              />
            </div>

            <div>
              <label className="block text-[13px] font-medium text-lightBlack mb-1.5">Password</label>
              <input
                type="password"
                name='password'
                placeholder="Choose a strong password"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-[14.5px] placeholder-gray-400"
                value={values?.password || ""}
                onChange={HandleChangeValues}
              />
            </div>

            <div>
              <label className="block text-[13px] font-medium text-lightBlack mb-1.5">Confirm Password</label>
              <input
                type="password"
                name='confirmPassword'
                placeholder="Re-enter your password"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-[14.5px] placeholder-gray-400"
                value={values?.confirmPassword || ""}
                onChange={HandleChangeValues}
              />
            </div>

            <Button children={"Create Account"} onClick={HandleRegister} disabled={loading} isLoading={loading} />
          </div>

          <div className="flex items-center gap-3 my-8">
            <div className="h-px flex-1 bg-gray-100"></div>
            <span className="text-xs text-gray-400 uppercase tracking-wider">or</span>
            <div className="h-px flex-1 bg-gray-100"></div>
          </div>

          <p className="text-center text-sm text-gray-500">
            Already have an account?{" "}
            <button onClick={() => NavigateTo("/login")} className="text-blue font-medium hover:underline">Sign In</button>
          </p>
        </div>
      </div>
    </div>

  );
};

export default SignUp;
